import { render, staticRenderFns } from "./ProfileAddressForm.vue?vue&type=template&id=329d27fd&v-if=isNewAddress&"
import script from "./ProfileAddressForm.vue?vue&type=script&lang=js&"
export * from "./ProfileAddressForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports